import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '../../assets/images/Instagram_logo@2x.png'
import _imports_1 from '../../assets/images/Facebook_logo@2x.png'
import _imports_2 from '../../assets/images/TikTok_logo@2x.png'
import _imports_3 from '../../assets/images/Twitter_logo@2x.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "stats-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex flex-justify-center flex-items-center my-3"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "px-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "stats-img",
    src: _imports_0
  })
], -1)
const _hoisted_6 = {
  key: 1,
  class: "d-flex flex-justify-center flex-items-center my-3"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "px-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "stats-img",
    src: _imports_1
  })
], -1)
const _hoisted_9 = {
  key: 2,
  class: "d-flex flex-justify-center flex-items-center my-3"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "px-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "stats-img",
    src: _imports_2
  })
], -1)
const _hoisted_12 = {
  key: 3,
  class: "d-flex flex-justify-center flex-items-center my-3"
}
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "px-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "stats-img",
    src: _imports_3
  })
], -1)
const _hoisted_15 = { key: 4 }
const _hoisted_16 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.team)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("a", {
              class: "stats-value",
              href: _ctx.team.instagramUrl,
              target: "_blank"
            }, [
              (_ctx.team.instagramFanCount>0)
                ? (_openBlock(), _createElementBlock("h1", {
                    key: 0,
                    style: _normalizeStyle(_ctx.getTextColor(_ctx.config))
                  }, _toDisplayString(_ctx.formatNumber(_ctx.team.instagramFanCount)), 5))
                : _createCommentVNode("", true),
              (_ctx.team.instagramFanCount===0)
                ? (_openBlock(), _createElementBlock("h1", {
                    key: 1,
                    style: _normalizeStyle(_ctx.getTextColor(_ctx.config))
                  }, "-", 4))
                : _createCommentVNode("", true),
              _createElementVNode("h6", {
                style: _normalizeStyle(_ctx.getTextColor(_ctx.config))
              }, "obserwujących", 4)
            ], 8, _hoisted_4),
            _hoisted_5
          ]))
        : _createCommentVNode("", true),
      (_ctx.team)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("a", {
              class: "stats-value",
              href: _ctx.team.facebookUrl,
              target: "_blank"
            }, [
              (_ctx.team.facebookFanCount>0)
                ? (_openBlock(), _createElementBlock("h1", {
                    key: 0,
                    style: _normalizeStyle(_ctx.getTextColor(_ctx.config))
                  }, _toDisplayString(_ctx.formatNumber(_ctx.team.facebookFanCount)), 5))
                : _createCommentVNode("", true),
              (_ctx.team.facebookFanCount===0)
                ? (_openBlock(), _createElementBlock("h1", {
                    key: 1,
                    style: _normalizeStyle(_ctx.getTextColor(_ctx.config))
                  }, "-", 4))
                : _createCommentVNode("", true),
              _createElementVNode("h6", {
                style: _normalizeStyle(_ctx.getTextColor(_ctx.config))
              }, "obserwujących", 4)
            ], 8, _hoisted_7),
            _hoisted_8
          ]))
        : _createCommentVNode("", true),
      (_ctx.team)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("a", {
              class: "stats-value",
              href: _ctx.team.tiktokUrl,
              target: "_blank"
            }, [
              (_ctx.team.tiktokFanCount>0)
                ? (_openBlock(), _createElementBlock("h1", {
                    key: 0,
                    style: _normalizeStyle(_ctx.getTextColor(_ctx.config))
                  }, _toDisplayString(_ctx.formatNumber(_ctx.team.tiktokFanCount)), 5))
                : _createCommentVNode("", true),
              (_ctx.team.tiktokFanCount===0)
                ? (_openBlock(), _createElementBlock("h1", {
                    key: 1,
                    style: _normalizeStyle(_ctx.getTextColor(_ctx.config))
                  }, "-", 4))
                : _createCommentVNode("", true),
              _createElementVNode("h6", {
                style: _normalizeStyle(_ctx.getTextColor(_ctx.config))
              }, "obserwujących", 4)
            ], 8, _hoisted_10),
            _hoisted_11
          ]))
        : _createCommentVNode("", true),
      (_ctx.team)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("a", {
              class: "stats-value",
              href: _ctx.team.twitterUrl,
              target: "_blank"
            }, [
              (_ctx.team.twitterFanCount>0)
                ? (_openBlock(), _createElementBlock("h1", {
                    key: 0,
                    style: _normalizeStyle(_ctx.getTextColor(_ctx.config))
                  }, _toDisplayString(_ctx.formatNumber(_ctx.team.twitterFanCount)), 5))
                : _createCommentVNode("", true),
              (_ctx.team.twitterFanCount===0)
                ? (_openBlock(), _createElementBlock("h1", {
                    key: 1,
                    style: _normalizeStyle(_ctx.getTextColor(_ctx.config))
                  }, "-", 4))
                : _createCommentVNode("", true),
              _createElementVNode("h6", {
                style: _normalizeStyle(_ctx.getTextColor(_ctx.config))
              }, "obserwujących", 4)
            ], 8, _hoisted_13),
            _hoisted_14
          ]))
        : _createCommentVNode("", true),
      (_ctx.ev && (_ctx.ev.statPhoto !== undefined && _ctx.ev.statPhoto !== null))
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("img", {
              src: _ctx.ev.statPhoto.url,
              class: "stats-image"
            }, null, 8, _hoisted_16)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}